import { fetch2, get, baseURL } from "./api";

// 发送验证码邮件(三方邮箱登录)
export function sendEmailCode(params: {
  email: string;
  type: "LOGIN" | "BIND";
}) {
  return fetch2<null>(baseURL + `/api/auth/sendCode`, params);
}

// 校验验证码(三方邮箱登录)
export function verifyEmailCode(params: { email: string; code: string }) {
  return fetch2<null>(baseURL + `/api/auth/verifyCode`, params);
}

// 检查登录状态
export function checkLogin(params?: { targetUrl?: string }) {
  return fetch2<{
    login: boolean;
    oldUser: boolean;
    needEmailLogin: boolean;
  }>(
    baseURL + `/api/auth/check_login`,
    {
      ...params,
      checkLinkedin: false, // 过渡参数，用于兼容旧逻辑
    },
    undefined,
    true,
  );
}

// 退出登录
export function authLogout() {
  return get<null>(baseURL + `/api/auth/logout`);
}

// 谷歌快捷登录
export function googleQuickLogin(params: { credential: string }) {
  return fetch2(baseURL + `/api/auth/google_quick_login`, params);
}

// 管理员代登录
export function adminLogin(params: {
  userId?: string;
  email?: string;
  token: string;
}) {
  return fetch2(baseURL + `/api/auth/login/admin`, params);
}

// ChatGPT 授权页：确认/取消都返回 redirectUrl，由前端跳回 ChatGPT 回调地址
function postChatGPTBinding(path: string, state: string) {
  return fetch2<{
    redirectUrl: string;
    code?: string;
    state?: string;
  }>(baseURL + path, { state });
}

export function confirmChatGPTBinding(state: string) {
  return postChatGPTBinding(`/api/auth/chatgpt/confirm-binding`, state);
}

export function cancelChatGPTBinding(state: string) {
  return postChatGPTBinding(`/api/auth/chatgpt/cancel`, state);
}
